import { DockModal } from './../../components/dock-modal/dock-modal';
import { ModalController } from 'ionic-angular';
import { Dock } from './../../models/Dock';
import { Injectable } from '@angular/core';

/*
  Generated class for the ModalProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ModalProvider {

  constructor(private modalCtrl: ModalController) {
  }


  open(dock: Dock) {
    let modal = this.modalCtrl.create(DockModal, {dock: dock})
    modal.present()
  }

}



// WEBPACK FOOTER //
// ./src/providers/modal/modal.ts